import { Badge, Box, Button, Grid, GridItem, HStack, IconButton, Separator, Spinner, Stack, Table, Text, useDisclosure, Tag } from "@chakra-ui/react";
import { UI } from "components";
import { Styles } from "config";
import { Mask } from "config";
import useOrder from "hooks/useOrder";
import moment from "moment";
import { useParams } from "react-router";
import Approve from "./approve";
import Cancel from "./cancel";
import { toaster } from "config";
import { API } from "config";
import { useState } from "react";
import History from "./history";
import Dispatch from "./dispatch";
import Withdraw from "./withdraw";

export default function Order(){

    const params = useParams()
    const order = useOrder(params.id)
    const consultant = order.data?.consultant?.customer
    const status = Styles.orderStatus(order.data?.status)
    const [ loading, setLoading ] = useState(false)

    const approve = useDisclosure()
    const cancel = useDisclosure()
    const history = useDisclosure()
    const dispatch = useDisclosure()
    const withdraw = useDisclosure()

    const tableItensColumns = [{ children: 'Produto' }, { children: 'Qtd', textAlign: 'center' }, { children: 'Und (R$)' }, { children: 'Total' }]
    const tableTransactionsColumns = [{ children: 'Método' }, { children: 'Valor' }, { children: 'Status' }, { children: '' }]

    const handleDone = async () => {
        if(!window.confirm("Tem certeza que deseja finalizar o pedido?")) return
        setLoading(true)

        try{
            await API.put(`/orders/${order?.data?.id}/done`)
            toaster.create({ title: 'O pedido foi concluído', type: 'success' })
            order.refetch()
        }catch(err){
            toaster.create({ title: 'Não foi possível concluir o pedido', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    const handleChangeComments = async (distributor_comments) => {
        if(distributor_comments === order.data.distributor_comments) return
        setLoading('username')

        try{
            await API.post(`/orders/${order.data?.id}/comments`, { distributor_comments, _method: 'put' })
            toaster.create({ title: 'Observações do pedido salvas', type: 'success' })
            order.refetch()
        }catch(err){
            toaster.create({ title: 'Não foi possível atualizar as observações.', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Approve data={order.data} {...approve} />
    <Cancel data={order.data} {...cancel} />
    <History data={order.data} {...history} />
    <Dispatch data={order.data} {...dispatch} />
    <Withdraw data={order.data} {...withdraw} />

    <UI.Header title={order?.data ? `Venda #${order.data?.cod}` : `Venda #${params?.id}`} />

    <UI.Show visible={order.isFetching}><UI.Alert my={4} size="sm" colorPalette="gray" indicator={<Spinner />}>Obtendo dados do pedido...</UI.Alert></UI.Show>

    <Stack mb={4}>
        <UI.Show visible={order.data?.status === 5}>
            <UI.Alert size="sm" colorPalette="red" title="Venda cancelada">Esta venda foi cancelada {moment(order.data?.canceled_at).fromNow()}. Verifique detalhes do pedido para mais informações. Os produtos foram devolvidos para o estoque e os pagamentos foram cancelados ou devolvidos ao consultor.</UI.Alert>
        </UI.Show>
    </Stack>

    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={6}>

        <GridItem>
            <UI.Box bg="transparent" borderWidth={1} borderStyle="dashed">
                <Stack gap={3}>
                    <Text fontSize="sm" color="GrayText">Informações do pedido:</Text>

                    <HStack>
                        { order.data?.type === 3 ? <Badge size="lg" colorPalette="purple" children="Adesão" /> : <Badge size="lg" colorPalette="gray" children="Produtos" /> }
                        <Badge size="lg" colorPalette={status.colorPalette}><UI.Icon name={status.icon} /> {status.label}</Badge>
                    </HStack>

                    <Box>
                        <Text fontSize="sm" color="GrayText">Tipo de entrega:</Text>
                        <Badge size="sm">{order.data?.shipping_type === 1 ? 'Para envio' : 'Retirada em mãos'}</Badge>
                    </Box>

                    <Separator />

                    <Box>
                        <Text fontSize="sm" color="GrayText">Data do pedido:</Text>
                        <Text fontSize="sm">{moment(order?.data?.created_at).format('LLL')}</Text>
                    </Box>

                    <Box>
                        <Text fontSize="sm" color="GrayText">Última atualização:</Text>
                        <Text fontSize="sm">{moment(order?.data?.created_at).fromNow()}</Text>
                    </Box>

                    <UI.Show visible={order.data?.status === 5}>
                        <Separator />

                        <Box>
                            <Text fontSize="sm" color="GrayText">Cancelado em:</Text>
                            <Text fontSize="sm">{moment(order?.data?.canceled_at).format('LLL')}</Text>
                        </Box>

                        <Box>
                            <Text fontSize="sm" color="GrayText">Motivo do cancelamento:</Text>
                            <Text fontSize="sm">{order?.data?.canceled_reason ?? <>&mdash;</>}</Text>
                        </Box>
                    </UI.Show>

                    <Separator />

                    <Stack gap={1}>
                        <UI.Show visible={order.data?.status === 12}><Button variant="subtle" colorPalette="green" size="xs" onClick={approve.onOpen}><UI.Icon name="check" /> Aprovar pedido</Button></UI.Show>
                        <UI.Show visible={order.data?.status === 12}><Button variant="subtle" colorPalette="red" size="xs" onClick={cancel.onOpen}><UI.Icon name="cancel" /> Cancelar pedido</Button></UI.Show>
                        <UI.Show visible={order.data?.status === 3 && order.data?.shipping_type === 1}><Button variant="subtle" colorPalette="blue" size="xs" onClick={dispatch.onOpen}><UI.Icon name="transit" /> Despachar pedido</Button></UI.Show>
                        <UI.Show visible={order.data?.status === 3 && order.data?.shipping_type === 2}><Button variant="subtle" colorPalette="blue" size="xs" onClick={withdraw.onOpen}><UI.Icon name="done" /> Marcar para retirada</Button></UI.Show>
                        <UI.Show visible={[9,11].includes(order.data?.status)}><Button variant="subtle" colorPalette="teal" size="xs" loading={loading} loadingText="Concluindo..." onClick={handleDone}><UI.Icon name="done" /> Concluir pedido</Button></UI.Show>
                    </Stack>

                    <Stack gap={1}>
                        <Button variant="subtle" colorPalette="gray" size="xs" onClick={history.onOpen}>Ver histórico do pedido <UI.Icon name="right" /></Button>
                        <Button variant="subtle" colorPalette="gray" size="xs" onClick={() => window.open(order.data?.print_url_for_distributor)}><UI.Icon name="print" /> Imprimir pedido</Button>
                    </Stack>
                </Stack>
            </UI.Box>
        </GridItem>

        <GridItem colSpan={{ base: 2, sm: 2, md: 1, lg: 2 }}>
            <UI.Box bg="transparent" p={0}>
                <Stack gap={3}>
                    <Text fontSize="sm" color="GrayText">Itens do pedido:</Text>

                    <UI.Table variant="outline" columns={tableItensColumns} data={order.data?.itens} meta={order.data?.meta} Row={Row} />

                    <Box>
                        <Text fontSize="xs" color="GrayText">Total do pedido:</Text>
                        <Text fontSize="lg" fontWeight="bold">R$ {Mask.price(order.data?.total_amount)}</Text>
                    </Box>
                </Stack>
            </UI.Box>
        </GridItem>

        <GridItem>
            <UI.Box>
                <Stack gap={3}>
                    <Text fontSize="sm" color="GrayText">Dados do consultor:</Text>

                    <Box>
                        <Text fontSize="sm" color="GrayText">Nome:</Text>
                        <UI.Tag.Avatar size="xl" name={consultant?.name} src={consultant?.avatar_url} />
                    </Box>

                    <UI.Show visible={!!consultant?.doc_cpf}>
                        <Box>
                            <Text fontSize="sm" color="GrayText">CPF:</Text>
                            <Text>{!!consultant?.doc_cpf && Mask.cpf(consultant?.doc_cpf)}</Text>
                        </Box>
                    </UI.Show>

                    <UI.Show visible={!!consultant?.doc_international}>
                        <Box>
                            <Text fontSize="sm" color="GrayText">Documento internacional:</Text>
                            <Text>{consultant?.doc_international}</Text>
                        </Box>
                    </UI.Show>

                    <Separator />

                    <Box>
                        <Text fontSize="sm"color="GrayText">Celular/Whatsapp:</Text>
                        <Text>{consultant?.mobile}</Text>
                    </Box>

                    <Box>
                        <Text fontSize="sm" color="GrayText">Endereço de e-mail:</Text>
                        <Text>{consultant?.email}</Text>
                    </Box>

                    <Separator />

                    <Box>
                        <Text fontSize="sm"color="GrayText">Endereço do consultor:</Text>
                        <Text fontSize="sm">{consultant?.address?.address} {consultant?.customer?.address?.line_1}, {consultant?.address?.number}, {consultant?.address?.neighborhood}</Text>
                        <Text fontSize="sm" fontWeight="bold">{consultant?.address?.zip} {consultant?.address?.city.name} {consultant?.address?.city.state_code}</Text>
                        <Text fontSize="xs" fontWeight="bold">{consultant?.address?.complement}</Text>
                    </Box>

                </Stack>
            </UI.Box>
        </GridItem>

        <GridItem colSpan={{ base: 2, sm: 2, md: 1, lg: 2 }}>
            <UI.Box bg="transparent" p={0}>
                <Stack gap={3}>
                    <Text fontSize="sm" color="GrayText">Pagamentos:</Text>

                    <UI.Table variant="outline" columns={tableTransactionsColumns} data={order.data?.transactions} Row={RowTransaction} />
                </Stack>
            </UI.Box>
        </GridItem>

        <GridItem>
            <UI.Box>
                <Text fontSize="sm" color="GrayText">Observações:</Text>

                <UI.Show visible={!order.isFetching}>
                    <UI.Editable
                        defaultValue={order.data?.distributor_comments ?? ''}
                        onValueCommit={e => handleChangeComments(e.value)}
                        placeholder="Clique para adicionar observações ao pedido..."
                        disabled={!!loading}
                    />
                </UI.Show>
            </UI.Box>
        </GridItem>

    </Grid>
    </>
    )
}

const Row = ({ data }) => {
    return(
    <Table.Row>
        <Table.Cell fontSize="xs"><UI.Tag.Avatar size="lg" name={data?.product?.name} src={data?.product?.image_url} /></Table.Cell>
        <Table.Cell fontSize="xs" textAlign="center"><Tag.Root colorPalette="orange"><Tag.Label>{data?.quantity}</Tag.Label></Tag.Root></Table.Cell>
        <Table.Cell fontSize="xs">R$ {Mask.price(data?.product?.consultant_price)}</Table.Cell>
        <Table.Cell fontSize="xs">R$ {Mask.price(data?.amount)}</Table.Cell>
    </Table.Row>
    )
}

const RowTransaction = ({ data }) => {

    const status = Styles.transactionStatus(data?.status)
    const method = Styles.transactionMethod(data?.method)

    return(
    <Table.Row>
        <Table.Cell fontSize="xs"><UI.Icon name={method.icon} /> {data?.method_label}</Table.Cell>
        <Table.Cell fontSize="xs" fontWeight="bold">R$ {Mask.price(data?.amount)}</Table.Cell>
        <Table.Cell fontSize="xs"><Badge colorPalette={status.colorPalette}>{data?.status_label}</Badge></Table.Cell>
        <Table.Cell fontSize="xs" textAlign="right">
            <UI.Show visible={data?.method === 4 && !!data?.receipt}><Button size="xs" variant="subtle" onClick={() => window.open(data?.receipt?.download_url)}><UI.Icon name="attach" /> Ver comprovante</Button></UI.Show>
        </Table.Cell>
    </Table.Row>
    )
}
